import { toFixed } from "../utils/helpers";

export const getRollNo = (rollNumber, charLength = 10, splitChar = "-") => {
  if (!rollNumber) return "";
  const splits = rollNumber.split(splitChar);
  if (splits[0].length > charLength) {
    if (splits[0].includes("(")) {
      rollNumber = splits[0].slice(-(charLength + 3));
    } else {
      rollNumber = splits[0].slice(-charLength);
    }
    if (splits[1]) {
      rollNumber += splitChar + splits[1];
    }
  }
  return rollNumber;
};

export const lengthFromWeight = (weight, gsm, width, precision = 2) => {
  return parseFloat(toFixed((weight * 100 * 1000) / (gsm * width), precision));
};

export const weightFromLength = (length, gsm, width, precision = 2) => {
  return parseFloat(toFixed((gsm * length * width) / (1000 * 100), precision));
};

export const getRepeatSize = ({ repeatLength, repeatWidth }) => {
  let repeatSize = "";
  if (repeatLength && repeatWidth) {
    repeatSize = `${toFixed(repeatLength, 1)} X ${toFixed(repeatWidth, 1)}`;
  } else if (repeatLength) {
    repeatSize = `${toFixed(repeatLength, 1)}`;
  } else if (repeatWidth) {
    repeatSize = `${toFixed(repeatWidth, 1)}`;
  }
  return repeatSize;
};

export const fabricRequired = (orderQty, orderingCu, extra) => {
  if (!orderQty || !orderingCu) return "";
  let reqFabric = parseFloat(orderingCu) * parseInt(orderQty);
  if (extra) {
    reqFabric = (1 + 0.01 * extra) * reqFabric;
  }
  return `${toFixed(reqFabric, 0)} meters`;
};

export const sanitizeRoll = roll => {
  const {
    supplierRoll,
    fabricItem,
    ledgerIn,
    ledgerOut,
    ledgerItem,
    fabricRelease,
    orderFlow,
    cutOrderFlow,
    shrinkageGroup,
    finalGroup,
    group,
    lay,
    layRowList,
    remnantGroup,
    fabric,
    order,
    ...rollInfo
  } = roll || {};
  return rollInfo;
};
